/**
 * Admin API client for global answer-analysis provider settings.
 *
 * @module answerAnalysisSettingsApi
 */

import { apiGet, apiPut } from '@/lib/apiUtils';

export interface AnswerAnalysisSettings {
  readonly provider: string;
  readonly defaultProvider: string;
  readonly allowedProviders: readonly string[];
}

export async function getAnswerAnalysisSettings(): Promise<AnswerAnalysisSettings | null> {
  return apiGet<AnswerAnalysisSettings>('/admin/answer-analysis/settings', {
    context: 'getAnswerAnalysisSettings',
    errorMessage: 'Failed to load answer analysis settings',
    errorReturnValue: null,
  });
}

export async function updateAnswerAnalysisProvider(
  provider: string,
): Promise<AnswerAnalysisSettings | null> {
  return apiPut<AnswerAnalysisSettings>(
    '/admin/answer-analysis/settings',
    { provider },
    {
      context: 'updateAnswerAnalysisProvider',
      errorMessage: 'Failed to update answer analysis provider',
      errorReturnValue: null,
    },
  );
}
